import { Icon, IconProps } from './Icon';

export type SliderArrowProps = IconProps;

export const SliderArrow = (props: SliderArrowProps) => (
  <Icon width="12px" height="28px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 28" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M.3.283c.375-.402.959-.372 1.304.066l10.153 12.923a1.213 1.213 0 0 1 0 1.456L1.604 27.65c-.345.438-.929.468-1.305.066-.375-.402-.4-1.083-.056-1.522L9.825 14 .243 1.805C-.102 1.366-.077.685.299.283Z" fill="currentcolor" fillOpacity=".8"/>
  </Icon>
)
